import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedGuia } from "./types";

/**Determina si una guia esta seleccionada */
function estaSeleccionada(item: models.GuiaDTO, selected: string[]): boolean {
    return contains(selected, item.Folio);
}

/**Obtiene un conjunto de guias a un conjunto de SelectedGuia */
export function toSelected(items: models.GuiaDTO[], selected: string[]): SelectedGuia[] {
    const ret =  items.map(x => ({ ...x, Selected: estaSeleccionada(x, selected) }));
    return ret;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/multiguias/logic.tsx